import React, { useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';

import { useJoinMachineShare } from '@/lib/api/orval/target/machines/machines';
import { errorMessage } from '@/lib/errors';
import { xpraPath } from '@/lib/xpra';

/**
 * Join a shared machine session via its secret share code.
 *
 * Resolves the session URI from the backend and hands off to the xpra client.
 */
export function ShareJoin(): React.ReactElement {
  const { publicId = '', code = '' } = useParams();
  const navigate = useNavigate();

  const { data, isLoading, error } = useJoinMachineShare(publicId, code, {
    query: { enabled: Boolean(publicId && code), retry: false },
  });

  useEffect(() => {
    if (data?.wss_uri) {
      navigate(xpraPath(data.wss_uri), {
        state: { wssUri: data.wss_uri, redirectUrl: `/m/${publicId}` },
        replace: true,
      });
    }
  }, [data, navigate, publicId]);

  if (isLoading) {
    return <p style={{ color: 'var(--text-secondary)' }}>Joining session…</p>;
  }
  if (error) {
    return (
      <div className="themed-card p-6 text-center flex flex-col gap-3">
        <p style={{ color: 'var(--danger)' }}>{errorMessage(error)}</p>
        <Link to="/" className="btn-primary self-center">
          Back home
        </Link>
      </div>
    );
  }
  return <p style={{ color: 'var(--text-secondary)' }}>Opening desktop…</p>;
}
